import { Users } from "lucide-react";

const GlobalUsersTileDesign = {
  id: "global-users",
  icon: Users,
  label: "Global Users",
  background: "#6D8196",
  color: "#ffffff",
};

export default GlobalUsersTileDesign;
